import { Component, OnInit } from '@angular/core';

import { ProjetoService } from "./projeto/shared/projeto.service";

@Component({
    selector: 'app-root',
    template: require('./app.component.html')
})
export class AppComponent implements OnInit {

    constructor(
        private _projetoService: ProjetoService
    ){}

    ngOnInit() {
       this._projetoService.getAllProjects();
    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/app.component.ts
 **/